import { notification } from "antd";

export const openNotification = ({
  title,
  description,
  state = "info",
  duration = 4.5,
}: {
  title: string;
  description: string;
  state?: "success" | "error" | "info" | "warning";
  duration?: number;
}) => {
  notification[state]({
    message: title,
    description: description,
    duration: duration,
    placement: "topRight",
  });
};
